export interface RedirectAccount {
  type: string;
  title?: string;
  url: string;
  saml?: string;
  lastFourCardNumber?: string;
  secondLevelValidated?: boolean;
  accountNumber?: string;
  accountStatus?: string;
}

export interface RedirectError {
  type: string;
  error: string;
}

export interface VerificationModalData {
  redirectAccount: RedirectAccount;
  idToken: string;
}

export enum SelfServiceableProducts {
  LOAN = 'loan',
  CARD = 'card',
  BECH = 'financial health',
}
